import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.PageNotFound.';
  public static readonly pageNotFoundTitle = `${Id.prefix}pageNotFoundTitle`;
  public static readonly backToHomeLink = `${Id.prefix}backToHomeLink`;
}

export class LangPageNotFound {
  private constructor() {}
  public static pageNotFoundTitle(): string {
    return interpolate(Id.pageNotFoundTitle);
  }
  public static backToHomeLink(): string {
    return interpolate(Id.backToHomeLink);
  }
}

export class PageNotFoundModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.pageNotFoundTitle, 'Page not found', 'Title for the page not found error page');
    register.add(Id.backToHomeLink, 'Back to home', 'Link text for returning to the home page from the not found page');
  }
}
